module.exports = __webpack_public_path__ + "assets/img/not_data_tips-8fca8055.png";